'use strict';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  windows: {
    interaction: [],
    focusedInteractionId: null,
    focusedElementId: null
  }
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state
};
